<template>
  <div>
    <CRow>
      <CCol sm="12">
        <MyAccountForm
          :items="customers"
          hover
          striped
          border
          small
          fixed
          caption="Mi Cuenta" 
          @refresh="refreshItems" 
        />
      </CCol>
    </CRow>
  </div>
</template>

<script>
import MyAccountForm from '../../../components/configuration/MyAccountForm.vue'
import store from '../../../store'

export default {
  name: 'MyAccount',
  components: { MyAccountForm },
  data: function () {
		return {
            customers: []
        }
  },
  mounted: async function() {
    this.loading();
    let response = await customers.get(); 

    if(response.type == "success"){
      this.customers = response.data;
    }
    this.loaded();
},
  methods: {
    async refreshItems (items){
      this.loading();
      this.customers = await items;
      this.loaded();
    },
    loading(){
      store.commit('loading');
    },
    loaded(){
      store.commit('loaded');
    }
  }
}
</script>
